<template>
  <div class="NavFlight">
    <!-- <div class="nav_flight_top">
		<a-radio-group :options="options" @change="onChange" v-model="value" />
	</div>
	<ul class="online_bottom clear">
      <li class="left">
        <h3>Flight Number</h3>
        <input type="text" value="3U6788" placeholder="3U6788" />
      </li>
      <li class="right">
        <h3>Depart</h3>
        <div class="clear">
			<span class="left">Mon 16 Jul 2020</span>
			<i class="right"></i>
		</div>
      </li>
    </ul>
	<div class="clear btn_cof">
		<button class="right"></button>
		<input :class="['right btn_input']" type="button" value="Search Flights">
	</div> -->
	<iframe src="/M/views/flightstatus/index.html?pageid=0" frameborder="0" width="1120px" height="337px" scrolling=no ></iframe>
  </div>
</template>

<script>
const options = [
    { label: 'By Flight Number', value: 0 },
    { label: 'By Routes', value: 1 },
];
export default {
  components: {
    
  },
  name: 'NavFlight',
  data () {
    return {
        options,
        value:0
    }
  },
  props: {

  },
  watch: {

  },
  methods: {
	onChange(e){
        this.value = e.target.value
    }
  },
  filters: {

  },
  computed: {

  },
  created () {
    
  },
  mounted () {
    
  },
  destroyed () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.NavFlight{
	padding-top: 32px;
	.nav_flight_top{
		line-height: 32px;
		margin-bottom: 16px;
		.ant-radio-group{
			&::v-deep .ant-radio-wrapper{
				margin-right: 53px;
				span.ant-radio + *{
					padding-right: 0;
				}
			}
		}
	}
	.online_bottom{
		margin-bottom: 32px;
		li{
			width: 544px;
			height: 72px;
			box-shadow:0px 1px 0px 0px rgba(236,238,240,1);
			h3{
				font-size:12px;
				color:rgba(128,128,128,1);
				line-height:14px;
				margin-top: 16px;
				margin-bottom: 7px;
			}
			input{
				font-size:16px;
				color:rgba(51,51,51,1);
			}
			div{
				span{
					font-size:16px;
					color:rgba(51,51,51,1);
				}
				i{
					display: inline-block;
					width: 16px;
					height: 16px;
					margin-top: 3px;
					background: url(../../../assets/home/icon_date_time_down.png) no-repeat center;
					background-size: 100% 100%;
				}
			}
		}
	}
	
}

</style>
